<template>
	<div class="template-composer-root" v-bind="attrsStylesClass">
		<div class="form-subtitle row align-items-center mx-0 mb-2">
			<div class="mr-4">{{ title }}:</div>


			<span v-if="!hidePersonalization && !readonly">
            <el-dropdown @command="onAddDynamicData" trigger="click">
                <a href="#" @click.prevent type="">
					<span class="text-muted font-weight-normal">Personalize</span>
                    <i class="fontello icon-arrow-combo"></i>
                </a>

				<template #dropdown>

					<el-dropdown-menu>
						<el-dropdown-item
							v-for="(item, index) in dynamicData"
							:key="index"
							:command="item">

							<div>{{ item.label }}</div>

						</el-dropdown-item>
					</el-dropdown-menu>
				</template>

            </el-dropdown>
			<ToolTipView>
<!--					v-pre is a directive to encode {{}}-->
				<div v-pre>
					Click the dropdown on the left to add personalization.
					<br/><br/>
					Each placeholder will be replaced with the relevant data before sending the message.
					<br/><br/>
					For example {{invitee_first_name}} will be replaced automatically with the first name of your client so you can use the same message template for multiple clients while keeping it personal.
				</div>
			</ToolTipView>
				</span>
			<!--						<div class="layout-spacer"></div>-->
			<el-button v-if="defaultText && !readonly"
					   size="small"
					   style="font-size: 10px;"
					   class="no-border"

					   plain
					   @click="onDefaultResetClicked">
				Restore default
			</el-button>

		</div>

		<!--		<FormEditorRow-->
		<!--			:input-debounce-delay="inputDebounceDelay"-->
		<!--			@change="notifyValueChanged"-->
		<!--			v-model="valueData"/>-->

		<qw-form :rules="rules" :model="{}" ref="mainForm">

			<component
				:is="composerComponentName"
				prop="modelValue"
				:type="type"
				ref="textarea"
				class="w-100"
				:readonly="readonly"
				v-model="valueData"
				:minRows="minRows"
				:multiline="multiline"
				autosize
				:input-debounce-delay="inputDebounceDelay"
				:placeholder="placeholder"
				@change="notifyValueChanged"></component>
		</qw-form>

		<!--        <EditorView-->
		<!--            v-model="valueData"-->
		<!--            ref="textarea"-->
		<!--            :placeholder="placeholder"-->
		<!--            @change="notifyValueChanged"/>-->
	</div>
</template>

<script>

import QwInput from "@/core/components/Controls/QwInput.vue";
import BaseVModelView from "@/core/components/BaseVModelView.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import FormEditorRow from "@/core/components/Form/FormEditorRow.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import {templateComposerCommonData} from "@/core/components/template/PlaceholdersData";
import {isEmpty} from "@/utils/helpers.js";

export default {
	name: "TemplateComposer",
	extends: BaseVModelView,
	components: {FormTextRow, FormEditorRow, ToolTipView, QwInput},
	inheritAttrs: false,

	props: {
		inputDebounceDelay: {Number, default: 1000},
		placeholder: {
			String,
			default: "Type here. Use the Personalize dropdown above to further personalize your message"
		},
		title: String,
		minRows: Number,
		isValueRequired: {Boolean, default: true},
		multiline: Boolean,
		defaultText: String,
		showEditMenu: {Boolean, default: false},
		hidePersonalization: Boolean,
		readonly: Boolean,
		isSimpleComposer: Boolean,
		dynamicData: {Array, default: () => templateComposerCommonData}
	},


	watch: {
		defaultText: {
			immediate: true,
			handler() {
				if (this.defaultText && isEmpty(this.modelValue)) {// && !this.value) {
					this.valueData = this.defaultText
					this.$emit('update:modelValue', this.valueData)
					this.$emit("input", this.valueData)
				}
			}
		},
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				if (!this.isSimpleComposer) {
					this.valueData = (newVal || "").split("\n").join("<br/>");
					// this.$emit('update:modelValue', this.valueData)
					// this.$emit("input", this.valueData)
				}
			},
		},
	},

	data() {
		return {
			valueData: "",
			rules: {
				modelValue: [
					{
						required: true,
						whitespace: false,
						validator: (rules, value, callback) => {
							let error
							if (this.isValueRequired && (this.valueData || "").trim().length === 0) {
								error = `Please fill in ${this.title.toLowerCase()}`
							}
							callback(error)
						},
						trigger: 'validate'
					}
				],
			}
		}
	},

	methods: {

		onDefaultResetClicked() {
			this.$analyticManager.trackEvent("Restore default clicked", this.analyticsPropsMethod())
			this.valueData = this.defaultText
			this.notifyValueChanged()
			this.$emit("onDefaultRestored") //must be after notifyValueChanged
		},
		onAddDynamicData(option) {
			let textToInsert = option.value
			this.$refs.textarea.insertTextAtCursor(textToInsert)
			this.notifyValueChanged()
		},
	},

	computed: {
		composerComponentName() {
			return this.isSimpleComposer ? "FormTextRow" : "FormEditorRow"
		},
		type() {
			return this.isSimpleComposer ? "" : "multiline"
		}
	},
}
</script>

<style lang="scss">
.template-composer-root {
	.no-border {
		border: none !important;
	}
	.el-dropdown{
		vertical-align: baseline;
	}
}
</style>
